if (!customElements.get('multicolumn-section')) {
  class MulticolumnSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const buttons = this.querySelectorAll("[data-show-more]");
      this.readMoreBtn = this.querySelector("[data-read-more]");

      if (buttons.length) {
        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const info = button.closest(".multicolumn-card__info");
            const description = info
              ? info.querySelector("[data-description]")
              : null;
            if (description) {
              description.classList.toggle("active");
              button.classList.toggle("active");
            }
          });
        });
      }

      if (this.readMoreBtn) {
        this.readMoreBtn.addEventListener("click", () => this.expandReadMore());
      }

      // Filter functionality
      this.initFilters();
    }

    expandReadMore() {
      const content = this.querySelector(".multicolumn__items");
      if (content && this.readMoreBtn) {
        const isExpanded =
          content.style.maxHeight && content.style.maxHeight !== "700px";
        content.style.maxHeight = isExpanded ? "700px" : "none";

        content.classList.toggle("expanded");

        const buttonText = this.readMoreBtn.querySelector(".button-text");
        if (buttonText) {
          buttonText.textContent = isExpanded
            ? this.dataset.viewMoreText || "Load More"
            : this.dataset.viewLessText || "View Less";
        }
      }
    }

    initFilters() {
      const filterButtons = this.querySelectorAll(".multicolumn__filter-btn");
      const filterItems = this.querySelectorAll(
        ".multicolumn-card[data-filter]"
      );

      if (!filterButtons.length) return;

      filterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const filterValue = button.getAttribute("data-filter");

          // Update active button
          filterButtons.forEach((btn) => btn.classList.remove("active"));
          button.classList.add("active");

          // Filter items
          filterItems.forEach((item) => {
            const itemFilter = item.getAttribute("data-filter");
            const itemCategories = itemFilter ? itemFilter.split(',') : [];
            
            if (filterValue === "all" || itemCategories.includes(filterValue)) {
              item.classList.remove("filter-hidden");
              item.classList.add("filter-visible");
            } else {
              item.classList.remove("filter-visible");
              item.classList.add("filter-hidden");
            }
          });

          // Show all blocks without data-filter attribute (non-filterable blocks)
          const allBlocks = button
            .closest("multicolumn-section")
            .querySelectorAll(".multicolumn-card");
          allBlocks.forEach((block) => {
            if (!block.hasAttribute("data-filter")) {
              block.classList.remove("filter-hidden");
              block.classList.add("filter-visible");
            }
          });
        });
      });
    }
  }

  customElements.define('multicolumn-section', MulticolumnSection);
}


if (!customElements.get('multicolumn-section-slider')) {
  class MulticolumnSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = null;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.wrapper = this.querySelector('.multicolumn__items');
      if (!this.wrapper) return;

      this.items = parseInt(this.dataset.items, 10) || 3;
      this.tabletItems = parseInt(this.dataset.tabletItems, 10) || 2;
      this.enableDesktop = this.dataset.enableDesktop === 'true';
      this.enableMobile = this.dataset.enableMobile === 'true';

      window.addEventListener('resize', this.handleResize);
      this.handleResize(); // run once on load
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroySlider();
    }

    handleResize() {
      const isMobile = window.innerWidth < 768;
      const shouldEnable = (isMobile && this.enableMobile) || (!isMobile && this.enableDesktop);

      if (shouldEnable && !this.sliderInstance) {
        this.initSlider();
      } else if (!shouldEnable && this.sliderInstance) {
        this.destroySlider();
      } else if (!shouldEnable && !this.sliderInstance) {
        // Ensure classes are reset properly when no slider is active
        this.wrapper.classList.remove('swiper-wrapper');
        this.wrapper.classList.add('f-grid');
        this.querySelectorAll('.multicolumn-card').forEach((card) => {
          card.classList.remove('swiper-slide');
        });
      }
    }

    initSlider() {
      // ensure wrapper classes are correct
      this.wrapper.classList.add('swiper-wrapper');
      this.wrapper.classList.remove('f-grid');
      this.querySelectorAll('.multicolumn-card').forEach((card) => {
        card.classList.add('swiper-slide');
      });

      const columnGap = window.getComputedStyle(this.wrapper).getPropertyValue('--f-column-gap');
      const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 20;

      this.sliderInstance = new window.FoxTheme.Carousel(
        this,
        {
          slidesPerView: 1.2,
          spaceBetween: spaceBetween,
          breakpoints: {
            768: { slidesPerView: this.tabletItems },
            1280: { slidesPerView: this.items }
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true
          }
        },
        [FoxTheme.Swiper.Mousewheel]
      );

      this.sliderInstance.init();
      this.classList.add('swiper-initialized');
    }

    destroySlider() {
      if (this.sliderInstance && this.sliderInstance.destroy) {
        this.sliderInstance.destroy(true, true);
        this.sliderInstance = null;
      }
      this.classList.remove('swiper-initialized');

      // restore grid layout
      this.wrapper.classList.remove('swiper-wrapper');
      this.wrapper.classList.add('f-grid');
      this.querySelectorAll('.multicolumn-card').forEach((card) => {
        card.classList.remove('swiper-slide');
      });
    }
  }

  customElements.define('multicolumn-section-slider', MulticolumnSlider);
}